import React, {Component} from 'react';
import { connect }        from 'react-redux';
import {Link}             from 'react-router-dom';
import RackingAluno from './ranking_aluno';
import RackingTurma from './ranking_turma';
import { GetListaMenuTopo,
        GetListaSubMenuTopo} from '../../../actions/scopoAction';

class Relatorio extends Component {

    componentWillMount() {

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:false,nome:this.props.menu.relatorio.nomeModulo}
           ]);
           this.props.GetListaSubMenuTopo([
            // {nome:"Ranking Alunos",link : null},
            // {nome:"Ranking Turmas",link : 1},
          ]);
      
    }

    render() {

        const obj = {}
        // switch (this.props.checkSelect) {
        //     case 1:
        //     obj.acao = <RackingTurma/>;          
        //     break;
        //     default:
        //     obj.acao = <RackingAluno/>;         
        //     break;
        // }
        return (
            <div>
                <div className="container-bg">
                    <div className="row">
                        <div className="col-md-3 col-xs-6">
                            <Link to={this.props.menu.relatorio.rankingAluno} className="btn btn-primary">Ranking Alunos</Link>
                        </div>
                        <div className="col-md-3 col-xs-6">
                            <Link to={this.props.menu.relatorio.rankingTurma} className="btn btn-primary">Ranking Turmas</Link>
                        </div>
                    </div>

                      {/* {obj.acao} */}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state){
    
        return { checkSelect         : state.scopoReducer.checkSelect,menu : state.configReducer.menu}
    }

export default connect(mapStateToProps,{GetListaMenuTopo,
    GetListaSubMenuTopo})(Relatorio);


// WEBPACK FOOTER //
// ./src/components/professor/relatorios/relatorio.js